module.exports = __webpack_public_path__ + "static/media/aaiDraw.59750263.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aaiDraw.png
// module id = 155
// module chunks = 0